const routes = [
  {
    url: /\/Auth\/validate-session/,
    method: 'Get',
    reply: function (request) {
      return [200, null]
    }
  },
  {
    url: /\/Auth\/oidc-callback\?code=(.*)&sessid=(.*)/,
    method: 'Get',
    reply: function (request) {
      return [200, null]
    }
  },
  {
    url: /\/Auth\/user-info/,
    method: 'Get',
    reply: function (request) {
      const baseUser = {
        sub: '14078501-a4fe-4e80-a505-0149b864f8fa',
        email: 'my.clear@clear.sale',
        email_verified: true,
        entity: '16b6d522-21f3-4fd5-b813-a58519f43ce4',
        name: 'MyClear Local'
      }

      return [200, { ...baseUser }]
    }
  }
]

export default routes
